import React from "react";
import { Skeleton, Tooltip } from "@mui/material";
import { ContentTooltiptLearningContinuumLevelMarkingInfo, useStyles } from "../ContentTooltip/ContentTooltip";

const LevelMarkingInfo = ({
  size,
  lc,
  level,
  currentCurriculum,
  marking,
  isLoading
}) => {
  const classes = useStyles();
  if (isLoading) {
    return (
      <Skeleton
        style={{
          width: size + 1,
          height: size + 1
        }}
        variant="rectangular"
        className="rounded"
      />
    )
  }

  if (!marking.exists) {
    return (
      <div
        style={{
          width: size,
          height: size
        }}
        // children={marking?.markingValue}
        className="rounded cursor-not-allowed bg-lines flex items-center justify-center text-xs"
      />
    )
  }
  return (
    <Tooltip
      arrow
      placement="top"
      id={`tooltip-guttman-chart-${marking.studentId}-${lc._id}-${level.levelId}-${level.gsId}`}
      title={
        <ContentTooltiptLearningContinuumLevelMarkingInfo
          lc={lc}
          level={level}
          marking={marking}
          currentCurriculum={currentCurriculum}
        />
      }
      classes={{ tooltip: classes.customWidthGuttmanChart }}
    >
      <div
        style={{
          width: size,
          height: size,
          backgroundColor: marking.markingPrimaryColor,
          color: marking.markingSecondaryColor,
        }}
        className={classes.infoGuttmanChart}
      >
        {/* {String (marking.markingValue)} */}
        {/* {lc.ulId || 'main'} */}
      </div>
    </Tooltip>
  );
};

export default LevelMarkingInfo;
